/**
 * LES CAPACITÉS D'UNE SESSION — l'étage « serveur » du drapeau `MANUEL_VIVANT`
 * (chantier « manuel vivant », MV-SOC-01, AD-MV-1).
 *
 * ─── Pourquoi deux étages ───────────────────────────────────────────────────
 *
 * Le drapeau de BUILD (`EXPO_PUBLIC_MANUEL_VIVANT`, `VITE_MANUEL_VIVANT`) dit
 * si le paquet CONTIENT les écrans du chantier. Il ne se retire pas à chaud :
 * l'application n'a pas de mise à jour à distance, et la préproduction est
 * partagée avec les testeurs TestFlight (F-18).
 *
 * La CAPACITÉ, rendue par le serveur à la connexion, dit si CE compte y a
 * droit. Elle se règle par foyer ou par organisation, sans redéploiement, et
 * c'est elle que les écrans lisent.
 *
 * Un écran du chantier s'affiche si et seulement si les DEUX sont vrais. La
 * règle vit ici, une fois, parce que l'application et la console l'appliquent
 * toutes deux — même raison que `savoirConvientA`.
 */
/** Rien d'allumé — l'état de tout compte tant qu'aucun réglage ne dit le contraire. */
export const CAPACITES_ETEINTES = { manuelVivant: false };
/**
 * Lit des capacités venues d'ailleurs — une réponse de connexion, une session
 * relue du stockage — sans jamais rien allumer par accident.
 *
 * Une session enregistrée avant le 8 octobre 2026 ne porte pas le champ, et un
 * serveur ramené à une version antérieure ne le rend plus : dans les deux cas
 * la réponse honnête est « éteint ». Seul le booléen `true` allume ; `1`,
 * `'true'` ou un objet mal formé n'allument rien.
 */
export function lireCapacites(brut) {
    if (brut === null || typeof brut !== 'object')
        return CAPACITES_ETEINTES;
    return { manuelVivant: brut.manuelVivant === true };
}
/**
 * LA règle d'affichage du chantier : build à 1 ET capacité vraie.
 *
 * `drapeauDeBuild` est la constante lue une fois par le module `drapeau.ts` de
 * chaque client ; `capacites` est ce que la session porte (absent = éteint).
 */
export function manuelVivantActif(drapeauDeBuild, capacites) {
    return drapeauDeBuild === true && capacites?.manuelVivant === true;
}
/* -------------------------------------------------------------------------- */
/* Le réglage — PUT /v1/admin/foyers/:id/capacites,                          */
/*              PUT /v1/admin/organisations/:id/capacites,                    */
/*              GET /v1/admin/capacites                                       */
/* -------------------------------------------------------------------------- */
/**
 * Ce sur quoi la capacité se règle (`DECISIONS-ARCHITECTE.md`, point 1) :
 * le FOYER — le compte titulaire, celui dont `Eleve.parentId` porte
 * l'identifiant — ou l'ORGANISATION.
 */
export const CIBLES_CAPACITE = ['foyer', 'organisation'];
/** Le code d'erreur du refus — distinct de `FORBIDDEN`, pour que le client sache quoi dire. */
export const CODE_MANUEL_VIVANT_INACTIF = 'MANUEL_VIVANT_INACTIF';
//# sourceMappingURL=capacites.js.map